import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  createSectionApi,
  getSectionByIdApi,
  updateSectionApi,
} from "../../Constants/api";

const CreateSection = () => {
  const history = useHistory();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [errors, setErrors] = useState({});

  const { title, description } = formData;

  useEffect(() => {
    if (id) {
      fetchSectionDetails(id);
    }
  }, [id]);

  const fetchSectionDetails = async (sectionId) => {
    try {
      const { data } = await getSectionByIdApi(sectionId);
      if (data && data.data) {
        setFormData({
          title: data.data.title || "",
          description: data.data.description || "",
        });
      }
    } catch (error) {
      console.error("Error fetching section details:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!title.trim()) newErrors.title = "Title is required";
    if (!description.trim()) newErrors.description = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        title,
        description,
      };

      if (id) {
        await updateSectionApi(id, payload);
      } else {
        await createSectionApi(payload);
      }

      setAlert(
        <SweetAlert
          success
          title={id ? "Updated!" : "Created!"}
          onConfirm={() => {
            setAlert(null);
            history.push("/dashboard/sections/all");
          }}
        >
          Section has been {id ? "updated" : "created"} successfully.
        </SweetAlert>
      );

    } catch (error) {
      console.error("Error submitting form:", error);
      setAlert(
        <SweetAlert
          danger
          title="Error"
          onConfirm={() => setAlert(null)}
        >
          Something went wrong.
        </SweetAlert>
      );
    } finally {
      setIsLoading(false);
    }
  };

  const ErrorMsg = ({ msg }) => (
    msg ? <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>{msg}</div> : null
  );

  return (
    <div className="card">
      <div className="card-header">
        <h3>{id ? "Edit Section" : "Create Section"}</h3>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Title <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control"
              name="title"
              value={title}
              onChange={handleChange}
              disabled={isLoading}
            />
            <ErrorMsg msg={errors.title} />
          </div>

          <div className="form-group">
            <label>Description <span className="text-danger">*</span></label>
            <textarea
              className="form-control"
              name="description"
              value={description}
              onChange={handleChange}
              rows="4"
              disabled={isLoading}
            />
            <ErrorMsg msg={errors.description} />
          </div>

          <button type="submit" className="btn btn-primary mt-3" disabled={isLoading}>
            {isLoading ? "Saving..." : (id ? "Update" : "Create")}
          </button>
          {id && (
            <button type="button" className="btn btn-secondary mt-3 ml-2" onClick={() => history.push("/dashboard/sections/all")} disabled={isLoading}>
              Cancel
            </button>
          )}
        </form>
      </div>
      {alert}
    </div>
  );
};

export default CreateSection;
